export const securityOptions: SelectorOption<string>[] = [
  {
    label: "Basic",
    value: "basic",
  },
  {
    label: "Form",
    value: "form",
  },
];

export const proxyOptions: SelectorOption<string>[] = [
  {
    label: "Socks5",
    value: "socks5",
  },
  {
    label: "HTTP(S)",
    value: "http",
  },
];

export const branchOptions: SelectorOption<string>[] = [
  {
    label: "master",
    value: "master",
  },
  {
    label: "development",
    value: "development",
  },
];
